import React, { useState, useEffect } from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import Navbar from '../Menus/Navbar'
import Footer from '../Menus/Footer'
import HOMEBANNER from '../images/HOMEBANNER.jpg'
import WASHINGMACHINE from '../images/WASHINGMACHINE.png'
import REF from '../images/REF.png'
import AC from '../images/AC.png'
import TV from '../images/TV.png'
import CountUp from 'react-countup';
import { FaSmile, FaMapMarkedAlt, FaThumbsUp } from 'react-icons/fa';
import { useInView } from 'react-intersection-observer';
import './Home.css'
import AOS from 'aos';
import { FaPhoneAlt } from 'react-icons/fa';
import { FaCalendarAlt, FaClock, FaHeadset } from 'react-icons/fa';
// import 'aos/dist/aos.css';
export default function Home() {

  const [ref, inView] = useInView({ triggerOnce: true });

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    city: '',
    appliance: '',
    issue: ''
  });

  const handleChange = e => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    const { name, phone, city, appliance, issue } = formData;
    const message = `New Complaint:%0AName: ${name}%0APhone: ${phone}%0ACity: ${city}%0AAppliance: ${appliance}%0AIssue: ${issue}`;
    const whatsappURL = `https://wa.me/919342851992?text=${message}`; // Replace with your number
    window.open(whatsappURL, '_blank');
  };




  return (
    <>
      <Navbar />

      <section id="Banner-home" className="banner-home" style={{ backgroundImage: `url(${HOMEBANNER})` }}>
        <div className="banner-overlay">
          <div className="banner-container">
            {/* Left Side */}
            <div className="banner-left glass-effect">
              <h1 className="headline">Home Appliance Service Center</h1>
              <a href="tel:+919342851992" className="call-btn">
                <FaPhoneAlt style={{ marginRight: '8px' }} />
                +919342851992
              </a>
            </div>

            {/* Right Side - Contact Form */}
            <div className="banner-right">
              <form className="contact-form" onSubmit={handleSubmit}>
                <input type="text" name="name" placeholder="Your Name" required onChange={handleChange} />
                <input type="tel" name="phone" placeholder="Phone Number" required onChange={handleChange} />
                <input type="text" name="city" placeholder="City" required onChange={handleChange} />
                <select name="appliance" required onChange={handleChange}>
                  <option value="">Select Appliance</option>
                  <option value="Washing Machine">Washing Machine</option>
                  <option value="Refrigerator">Refrigerator</option>
                  <option value="AC">AC</option>
                  <option value="TV">TV</option>
                </select>
                <textarea name="issue" placeholder="Tell us your issue..." required onChange={handleChange}></textarea>
                <button type="submit" className="submit-btn">Submit & Send to WhatsApp</button>
              </form>
            </div>
          </div>
        </div>
      </section>




      <section id="home-about">
        <div className="about-container">
          {/* Left Side */}
          <div className="about-left" data-aos="fade-left">
            <h2>About Our Company</h2>
            <h3>Home Appliance Assist</h3>
            <p>
              If your home appliance breaks down, don't worry. Contact us, and we'll take care of the problem swiftly and professionally. We provide convenient, on-site repairing services for all your home appliances — just schedule a service call, and our experts will come to you. Or, visit us directly and our skilled technicians will fix the issue promptly. We provide reliable and professional home appliance services including <strong>AC Service, TV Service, Refrigerator Service,</strong> and <strong>Washing Machine Service</strong>. With over <strong>8+ years</strong> of experience in the service industry, we are committed to excellence and customer satisfaction.
            </p>

          </div>

          {/* Right Side Boxes */}
          <div className="about-right">
            <div className="service-box" data-aos="fade-right" data-aos-delay="100">
              <p>AC Service</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="200">
              <p>TV Service</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="300">
              <p>Refrigerator Service</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="400">
              <p>Washing Machine Service</p>
            </div>
          </div>
        </div>
      </section>






      <section id="desc" className="service-section">
        <div className="service-item" data-aos="fade-right">
          <div className="service-text">
            <h2>Washing Machine Issues?</h2>
            <p>
              Is your washing machine making noise, not spinning, or leaking water? Don’t worry — our trained experts diagnose and fix all issues quickly.
              We offer <strong>same-day doorstep service</strong> to get your appliance back up and running smoothly.
            </p>
            <a href="/washing-machine-service" className="service-btn">Fix Now</a>
          </div>
          <div className="service-image" data-aos="fade-left">
            <img src={WASHINGMACHINE} alt="Washing Machine Service" />
          </div>
        </div>

        <div className="service-item" data-aos="fade-right">
          <div className="service-text">
            <h2>AC Not Cooling?</h2>
            <p>
              Whether it's low cooling, water leakage, or unusual noise, our technicians provide <strong>same-day AC repair</strong> with expert diagnostics and professional care.
            </p>
            <a href="/ac-service" className="service-btn">Fix Now</a>
          </div>
          <div className="service-image" data-aos="fade-left">
            <img src={AC} alt="AC Service" />
          </div>
        </div>

        <div className="service-item" data-aos="fade-right">
          <div className="service-text">
            <h2>Fridge Not Working?</h2>
            <p>
              Experiencing cooling issues or strange noises? Let our experienced technicians help. We offer <strong>quick same-day service</strong> for all fridge problems.
            </p>
            <a href="/fridge-service" className="service-btn">Fix Now</a>
          </div>
          <div className="service-image" data-aos="fade-left">
            <img src={REF} alt="Fridge Service" />
          </div>
        </div>

        <div className="service-item" data-aos="fade-right">
          <div className="service-text">
            <h2>TV Not Turning On?</h2>
            <p>
              From screen issues to sound problems, we repair all types of TVs — LED, LCD, Smart TVs and more. Our <strong>same-day service</strong> ensures quick solutions.
            </p>
            <a href="/tv-service" className="service-btn">Fix Now</a>
          </div>
          <div className="service-image" data-aos="fade-left">
            <img src={TV} alt="TV Service" />
          </div>
        </div>
      </section>



      <section id="why-us" className="why-us-section">
        <div className="why-us-heading" data-aos="fade-up">
          <h2>Why Choose Us?</h2>
        </div>
        <div className="why-us-grid">
          <div className="why-us-card" data-aos="fade-right">
            <h3>Expert Technicians</h3>
            <p>Our team consists of certified experts with years of experience in appliance repairing and maintenance.</p>
          </div>
          <div className="why-us-card" data-aos="fade-left">
            <h3>Quick Service</h3>
            <p>We value your time and offer prompt service, ensuring your appliances are up and running in no time.</p>
          </div>
          <div className="why-us-card" data-aos="fade-right">
            <h3>Quality Assurance</h3>
            <p>We use genuine parts and provide a guarantee on our work, so you can trust in the quality of our service.</p>
          </div>
          <div className="why-us-card" data-aos="fade-left">
            <h3>Affordable Pricing</h3>
            <p>Our pricing is transparent and competitive, ensuring you get the best value for your money.</p>
          </div>
        </div>
      </section>

      <section id="impact" className="impact-section" ref={ref}>
        <h2 className="impact-heading" data-aos="fade-up">Our Impact in Numbers</h2>
        <div className="impact-container">
          <div className="impact-card" data-aos="fade-up" data-aos-delay="100">
            <FaSmile className="impact-icon" />
            <h2>{inView && <CountUp end={50000} duration={2} />}+</h2>
            <p>Happy Customers</p>
          </div>
          <div className="impact-card" data-aos="fade-up" data-aos-delay="200">
            <FaMapMarkedAlt className="impact-icon" />
            <h2>{inView && <CountUp end={60} duration={2} />}+</h2>
            <p>Areas Covered</p>
          </div>
          <div className="impact-card" data-aos="fade-up" data-aos-delay="300">
            <FaThumbsUp className="impact-icon" />
            <h2>{inView && <CountUp end={49000} duration={2} />}+</h2>
            <p>Satisfied Customers</p>
          </div>
        </div>
      </section>


      <section id="availability" className="availability-section">
        <h2 className="availability-heading" data-aos="fade-up">Our Availability</h2>
        <div className="availability-grid">
          <div className="availability-card" data-aos="fade-right">
            <FaCalendarAlt className="availability-icon" />
            <h3>Opening Day</h3>
            <p>
              Monday to Saturday <br />
              <span className="sunday-text">Sunday - Closed</span>
            </p>
          </div>
          <div className="availability-card" data-aos="fade-up">
            <FaClock className="availability-icon" />
            <h3>Office Available</h3>
            <p>9:00 AM to 9:00 PM</p>
          </div>
          <div className="availability-card" data-aos="fade-left">
            <FaHeadset className="availability-icon" />
            <h3>Customer Support</h3>
            <p>24/7 Available</p>
          </div>
        </div>
      </section>


      <section id="disclaimer" className="disclaimer-section" data-aos="fade-up">
        <div className="disclaimer-container">
          <div className="disclaimer-icon">
            <FaExclamationTriangle />
          </div>
          <div className="disclaimer-content">
            <h2>Disclaimer</h2>
            <p>
              Home Appliance Assist is an independent service provider offering expert repairing and maintenance services for a wide range of home appliances. We specialize in servicing all major home appliance types, including refrigerators, washing machines, air conditioners, and televisions.
            </p>
            <p>
              Please note that Home Appliance Assist is not affiliated with, endorsed by, or associated with any specific appliance manufacturers or brands. We do not use any brand names, trademarks, or logos on our website or in our promotional materials. All services provided are carried out by our team of experienced and certified technicians, independent of any manufacturer's certification.
            </p>
            <p>
              While we provide high-quality service for various appliance types, our services are not authorized by or affiliated with the manufacturers of the products we repair. Customers seeking manufacturer-authorized service and genuine parts should contact the official customer support of the respective brands.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </>
  )
}
